import { useCallback } from 'react';
import { atom, useAtom } from 'jotai';
import { groupAtom, useDashboardStatus, useClearGroup } from 'state/dashboard';
import { useAddressQuery } from 'state/queryParams';
import { GroupRawResponse } from 'types';
import { groupRawToGroup } from 'utils/transforms';

export const useResetAllToolbarFilters = () => {
  const { clearGroup } = useClearGroup();

  return { resetAllToolbarFilters: clearGroup };
};

export const useResetFilterValues = () => {
  const [, setAddress] = useAddressQuery();
  const [, setStatus] = useDashboardStatus();
  const [, setGroup] = useAtom(groupAtom);

  const resetFilterValuesForGroupChange = useCallback(
    (group: GroupRawResponse) => {
      // use it like this
      setGroup(groupRawToGroup(group));
      // default to active state when switching groups
      setStatus('active');
      setAddress('');
    },
    [setGroup, setStatus, setAddress],
  );

  return {
    resetFilterValuesForGroupChange,
  };
};

const latestStageFilterErrorAtom = atom<string | undefined>('');

export const useFilterToolbarErrors = () => {
  const [latestStageFilterError, setLatestStageFilterError] = useAtom(
    latestStageFilterErrorAtom,
  );

  return {
    latestStageFilterError,
    setLatestStageFilterError,
  };
};
